export { SpaDayConnected as SpaDay } from './container';
